import { Carousel } from "react-bootstrap";

export default function Testimonials() {
  const testimonials = [
    {
      name: "Jane Doe",
      text: "Dessert Haven made our party unforgettable with their delightful treats!",
      heading: "Best Desserts Ever",
    },
    {
      name: "John Smith",
      text: "Highly recommend their gluten-free options. They're a game changer!",
      heading: "Excellent Service",
    },
    {
      name: "Emma Brown",
      text: "The customizable treat boxes are perfect for gifting. So creative!",
      heading: "Perfect for Gifts",
    },
  ];

  return (
    <section className="testimonials">
      <div className="container">
        <div className="testimonial-heading text-center">
          <span className="section-eyebrow">SWEET WORDS</span>

          <h2>What our customers say</h2>
        </div>

        <Carousel
          indicators={false}
          interval={5000}
          controls={true}
          pause="hover"
        >
          {testimonials.map((testimonial, index) => (
            <Carousel.Item key={index}>
              <div className="testimonial-slide">
                <div
                  className="testimonial-stars"
                  aria-label="5 out of 5 stars"
                >
                  ★★★★★
                </div>

                <h3>{testimonial.heading}</h3>

                <p className="testimonial-text">"{testimonial.text}"</p>

                <p className="testimonial-name">{testimonial.name}</p>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </section>
  );
}
